import { useModuleGate } from '../../../lib/moduleGate';

/**
 * True when the native Cycle Designer should be used (create flow, setup
 * redirect, /designer route).
 *
 * Canonical gate (build contract §2.7): cycle_designer_v2 workspace module +
 * policy userDefault, with the user's flag as the personal override when the
 * policy allows it. The module starts on (owner ruling 2026-10-14); an admin
 * can switch it off.
 */
export function useCycleDesignerEnabled(): boolean {
  return useModuleGate('cycle_designer_v2');
}
